<div class="centralize-all">
  <div class="container">
    <div *ngIf="gates.length <= 0" class="welcome">
      <div class="welcome-content" *ngIf="canEdit; else notEditor">
        <div class="welcome-image">
          <img src="assets/images/gate-welcome.svg" />
        </div>
        <div class="welcome-messages">
          <div class="welcome-text">
            <label class="label-hello"
              >Oi {{ user?.firstName }}, vamos começar?</label
            >
          </div>
          <div class="welcome-todo">
            <label class="label-todo">Crie uma portaria </label>
          </div>
          <div class="welcome-create">
            <button
              mat-raised-button
              class="btn-create-first-gate"
              (click)="openCreateDialog()"
            >
              + Criar Portaria
            </button>
          </div>
        </div>
      </div>
      <ng-template #notEditor>
        <div class="welcome-container-no-edit">
          <img
            class="welcome-image-no-edit"
            src="../../../../../../assets/images/no-gates.svg"
          />
          <h2 class="welcome-title-no-edit">Oops!</h2>
          <p class="welcome-text-no-edit">
            Você ainda não está vinculado(a) a nenhuma portaria
          </p>
        </div>
      </ng-template>
    </div>
    <div *ngIf="gates.length > 0" class="gates">
      <div class="title">
        <label class="label-title">Portarias</label>
      </div>
      <div class="list">
        <app-gate-card
          *ngFor="let gate of gates"
          [gateName]="gate.name"
          (editClicked)="openEditDialog(gate)"
          (removeClicked)="delete(gate)"
          [gateid]="gate.id"
          (monitoreClicked)="monitoreGate(gate.id)"
        >
        </app-gate-card>
      </div>
      <div class="bottom-space"></div>
      <div *ngIf="canEdit" class="command">
        <button
          mat-raised-button
          class="btn-create-gate"
          (click)="openCreateDialog()"
        >
          + Criar Portaria
        </button>
      </div>
    </div>
  </div>
</div>
